import { render, staticRenderFns } from "./SX.vue?vue&type=template&id=6884f62b&scoped=true&"
import script from "./SX.vue?vue&type=script&lang=js&"
export * from "./SX.vue?vue&type=script&lang=js&"
import style0 from "./SX.vue?vue&type=style&index=0&id=6884f62b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884f62b",
  null
  
)

export default component.exports